import React from "react";
import { Modal } from "antd";

const ReminderDeleted = ({ isDeletedModalOpen, setIsDeletedModalOpen }) => {
  const handleOk = () => {
    setIsDeletedModalOpen(false);
  };

  const handleCancel = () => {
    setIsDeletedModalOpen(false);
  };

  return (
    <>
      <Modal
        open={isDeletedModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className="deleted-modal"
        centered={true}
        width="35%"
      >
        <div className="modal-content flex flex-col items-center p-[34px] gap-[10px]">
          <img
            src="../../assets/gifs/check.gif"
            alt=""
            className="w-[91px] h-[91px]"
          />
          <h5 className="text-blue font-manrope text-center font-medium max-w-[327px]">
            Deleted!
          </h5>
        </div>
      </Modal>
    </>
  );
};

export default ReminderDeleted;
